<template>
  <div ref="mapContainer" class="mc-liveview__map" data-testid="map-container"
    :class="{ 'detail-panel-open': selectedDetail }">
    <LeafletTechnician ref="leaflet" />
    <!-- Toggle sidebar: selalu di sisi kanan peta, vertikal tengah -->
    <button class="mc-map-toggle-sidebar" :aria-label="sidebarOpen ? 'Sembunyikan sidebar' : 'Tampilkan sidebar'"
      :title="sidebarOpen ? 'Tutup sidebar' : 'Buka sidebar'" @click="toggleSideBar">
      <i class="mc-fa fas" :class="sidebarOpen ? 'fa-angle-right' : 'fa-angle-left'" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import LeafletTechnician from './LeafletTechnician'

export default {
  name: 'Map',
  components: {
    LeafletTechnician,
  },
  computed: {
    sidebarOpen() {
      return this.$store.state.sidebar.sideBarOpen
    },

    selectedDetail() {
      return this.$store.state.map.selectedTechnician
    }
  },
  watch: {
    selectedDetail() {
      this.$nextTick(() => {
        this.$refs.leaflet?.invalidateMap();
      });
    }
  },
  mounted() {
    const observer = new ResizeObserver(() => {
      // Panggil method invalidate di child jika ada
      this.$refs.leaflet?.invalidateMap?.();
    });
    observer.observe(this.$refs.mapContainer);
    this.$once('hook:beforeDestroy', () => observer.disconnect());
  },
  methods: {
    ...mapMutations('sidebar', ['toggleSideBar']),
  }
}
</script>

<style scoped>
.mc-liveview__map {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.mc-liveview__map.detail-panel-open {
  margin-right: 340px;
  transition: margin-right 0.2s ease;
}

@media (max-width: 768px) {
  .mc-liveview__map.detail-panel-open {
    margin-right: 0;
  }
}

.mc-map-toggle-sidebar {
  position: absolute;
  right: 0;
  /* persis di tepi kanan area peta */
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  /* di atas elemen peta */
  width: 36px;
  height: 72px;
  background: #ffffff;
  border: 1px solid #dbe2ea;
  border-radius: 14px 0 0 14px;
  /* setengah pil melengkung ke kiri */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: -4px 0 12px rgba(15, 23, 42, 0.08);
  color: #64748b;
  transition: background 0.2s ease, color 0.2s ease;
}

.mc-map-toggle-sidebar:hover {
  background: #f8fafc;
  color: #0f172a;
}
</style>
